// Bane 2: Thor går i land (2031). Vestkysten fra Thorsminde til Esbjerg, Endrup og Revsing.
// Nyt: luft eller kabel, søkabel, gravko og ankerslæb. Finalen: Thor åbner med fuld kraft, 1 GW på én gang,
// mens to ankerbåde og en gravko kommer.

import type { LevelDef } from '../../sim/types';

export const LEVEL_02: LevelDef = {
  id: '02-thor-gaar-i-land',
  number: 2,
  title: 'Thor går i land',
  year: 2031,
  intro: 'Danmarks største havvindpark skal i land. Esbjerg venter, og en fiskerbåd har et anker, den glemmer at hive op.',
  view: [-35, 140, 110, 300],
  greenGoalPct: 70,
  sites: [
    { node: 'esbjerg', kind: 'city', tier: 2, maxTier: 3 },
    { node: 'horns_rev', kind: 'offshore', name: 'Horns Rev', capMw: 400, fee: 0 },
    { node: 'endrup', kind: 'station' },
    { node: 'varde', kind: 'city', tier: 0, maxTier: 2 },
    { node: 'revsing', kind: 'station', at: [10, 20] },
    { node: 'thor', kind: 'offshore', name: 'Thor Havvind', capMw: 1000, fee: 10, at: 120 },
    // Kunder i køen.
    { node: 'tjaereborg', kind: 'wind', name: 'Tjæreborg Vind', capMw: 250, at: 'pool' },
    { node: 'ribe', kind: 'city', tier: 0, maxTier: 2, at: 'pool' },
    { node: 'grindsted', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'hvide_sande', kind: 'wind', name: 'Hvide Sande Vind', capMw: 250, at: 'pool' },
    { node: 'ringkobing', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'thorsminde', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    // Skjern ligger midt mellem Varde og Ringkøbing; Blåvand er en ny gren ud til Vestkysten.
    { node: 'skjern', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'blaavand', kind: 'wind', name: 'Blåvand Vind', capMw: 250, at: 'pool' },
  ],
  // Horns Rev lander ved Blåbjerg og føres til Endrup; COBRA-kablet fra Holland ender også i Endrup.
  lines: [
    { a: 'horns_rev', b: 'endrup', medium: 'sea', tier: 2 },
    { a: 'holland', b: 'endrup', medium: 'hvdc', capMw: 700 },
    { a: 'endrup', b: 'esbjerg', medium: 'air', tier: 2 },
  ],
  mechanics: ['air', 'upgrade', 'double', 'cable', 'sea', 'crew', 'reinforce', 'station', 'shoo'],
  eventMenu: ['storm', 'digger', 'anchor', 'protest', 'heatwave'],
  // Ét nyt i hvert år: ankerbåden (scriptet i år 1), naboerne, stormen, gravkoen og til sidst varmen.
  news: [['anchor'], ['protest'], ['storm'], ['digger'], ['heatwave']],
  scripted: [
    { kind: 'anchor', at: [40, 50], warnS: 10 },
    // Finalen: Thor åbner, og to ankerbåde og en gravko kommer på én gang.
    { kind: 'anchor', at: 6, warnS: 8, finale: true },
    { kind: 'digger', at: 10, warnS: 8, finale: true },
    { kind: 'anchor', at: 18, warnS: 8, finale: true },
  ],
  growth: [{ node: 'esbjerg', at: [25, 30], tier: 3 }],
  boosts: [{ node: 'thor', at: 302, mw: 1000, seconds: 20 }],
  years: 5,
  finaleS: 40,
  clockFrozenUntilYear: 0,
  startCrews: 1,
  shipHome: 'esbjerg',
  crewHome: 'esbjerg',
  packs: [
    ['cable_discount', 'two_crews'],
    ['free_air3', 'free_double'],
    ['town_meeting', 'two_crews'],
    ['two_crews', 'free_air3'],
    ['free_station', 'free_air3'],
  ],
};
